

















































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { LoanStatusRow } from "../table-data/LoanStatusRow"
import { LoanStatusRowData } from "../table-data/LoanStatusRowData"

export interface TableField {
    key: string,
    label: string,
}

type RowKey = keyof LoanStatusRow

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class ReportLoanStatus extends Vue {

    // region Props
    @Prop({
        type: Object,
        required: true,
    })
    public readonly tableData!: LoanStatusRowData

    @Prop({
        type: Date,
        required: true,
    })
    public readonly date!: Date
    // endregion

    // region Data
    currentRows: LoanStatusRow[] = this.tableData.tengeRows
    public columns: TableField[] = [
        {
            key: 'name',
            label: 'Наименование'
        },
        {
            key: 'type',
            label: 'Тип'
        },
    ]
    totalRow: LoanStatusRow = this.tableData.tengeRows[0]
    yearKeys: string[] = []
    tengeYearKeys: string[] = []
    dollarYearKeys: string[] = []
    dummyRadio = 1
    // endregion

    // #region Computed
    // #endregion

    // region LifeCycle
    private created() {
        const uniqueTengeYearKeys = new Set<string>(
            Object.keys(this.tableData.tengeRows[0].yearPrincipalDict)
                .concat(Object.keys(this.tableData.tengeRows[0].yearInterestDict))
                .filter(k => /^\d+$/.test(k))
        )
        const tengeKeyYears: string[] = [...uniqueTengeYearKeys]
            .map(Number)
            .sort((a, b) => a - b)
            .map(String)

        const uniqueDollarYearKeys = new Set<string>(
            Object.keys(this.tableData.dollarRows[0].yearPrincipalDict)
                .concat(Object.keys(this.tableData.dollarRows[0].yearInterestDict))
                .filter(k => /^\d+$/.test(k))
        )
        const dollarKeyYears: string[] = [...uniqueDollarYearKeys]
            .map(Number)
            .sort((a, b) => a - b)
            .map(String)
        
        this.tengeYearKeys = tengeKeyYears
        this.dollarYearKeys = dollarKeyYears

        this.yearKeys = tengeKeyYears
    }
    // endregion

    // region Methods
    onCurrencyChange(currency: 'tenge' | 'usa_dollar') {
        if (currency === 'tenge') {
            this.currentRows = this.tableData.tengeRows
            this.totalRow = this.tableData.tengeRows[0]
            this.yearKeys = this.tengeYearKeys
        } else if (currency === 'usa_dollar') {
            this.currentRows = this.tableData.dollarRows
            this.totalRow = this.tableData.dollarRows[0]
            this.yearKeys = this.dollarYearKeys
        }
    }

    /** Метод-обертка для $t */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
        const text: string = String(this.$t(`${translationKey}.${key}`))

        return text
    }
    // endregion
}
